import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { environment } from '@environments/environment';

/**
 * Lazily initialise a single Firebase app + Auth instance for the OTA, pointed
 * at the guest-genie Firebase project. Guarded so it is only ever created in the
 * browser (the SDK touches `window`/IndexedDB) and only once per page load.
 */
let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseAuth(): Auth {
  if (!app) {
    app = getApps()[0] ?? initializeApp(environment.firebase);
  }
  if (!auth) {
    auth = getAuth(app);
  }
  return auth;
}
